import { useEffect, useState } from 'react';

const Duo = () => {
  const headCls = 'text-2xl font-bold mb-4';
  const priceCls = 'text-3xl font-extrabold mb-2';
  const [offer, setOffers] = useState([]);
  useEffect(() => {
    fetch('/data/offer.json')
      .then((res) => res.json())
      .then(setOffers)
      .catch(console.error);
  }, []);
  if (!offer) return <p>Ładowanie danych…</p>;
  console.log(offer);
  const trainig = offer?.data?.find((o) => o.name === 'DUO');
  const singleTrainingPrice = trainig?.offers?.find(
    (o) => o.period === 1
  ).price;
  return (
    <div class="max-w-7xl mx-auto space-y-6">
      <h1 class="text-4xl font-bold text-center mb-4 mt-4">
        Pakiety TRENINGI DUO (2 osoby)
      </h1>
      <h3 class="text-1xl text-center mb-8 mt-4 text-gray-300">
        Trening w parze to idealna opcja dla osób, które chcą ćwiczyć wspólnie z
        partnerem/partnerką lub przyjacielem. <br /> Trening jest indywidualnie
        dopasowany do każdej osoby, a wspólna motywacja i zdrowa rywalizacja
        pomogą Ci osiągnąć lepsze rezultaty.
      </h3>
      <div class="grid grid-cols-1 md:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6">
        {trainig?.offers?.map((i, index) => (
          <div
            key={index}
            class="bg-gray-800 p-8 rounded-3xl shadow-xl flex flex-col justify-between"
          >
            <div>
              <h2 class={headCls}>
                {i.special && '✅'}
                {i.name}
              </h2>
              <p class={priceCls}>
                {i.price} zł {i.period === 1 && `(${i.price / 2} zł/os.)`}
              </p>
              {i.period > 1 && (
                <p class="text-xl font-semibold text-green-400">
                  ({Math.round(i.price / 2 / i.period)} zł/os./trening —
                  oszczędzasz {i.special && 'aż'}
                  <b> {singleTrainingPrice * i.period - i.price} zł</b>)
                </p>
              )}
            </div>
          </div>
        ))}
        {/* <div class="bg-gray-800 p-8 rounded-3xl shadow-xl flex flex-col justify-between">
          <div>
            <h2 class={headCls}>Trening pojedynczy</h2>
            <p class={priceCls}>200 zł (100zł/os.)</p>
          </div>
        </div>

        <div class="bg-gray-800 p-8 rounded-3xl shadow-xl flex flex-col justify-between">
          <div>
            <h2 class={headCls}>Pakiet 4 treningów</h2>
            <p class={priceCls}>750 zł </p>
            <p class="text-xl font-semibold text-green-400">
              (93,75 zł/os./trening — oszczędzasz<b> 50 zł</b>)
            </p>
          </div>
        </div>

        <div class="bg-gray-800 p-8 rounded-3xl shadow-xl flex flex-col justify-between">
          <div>
            <h2 class={headCls}>Pakiet 8 treningów</h2>
            <p class={priceCls}>1 200 zł</p>
            <p class="text-xl font-semibold text-green-400">
              (75 zł/os./trening — oszczędzasz 400 zł)
            </p>
          </div>
        </div>

        <div class="bg-gray-800 p-8 rounded-3xl shadow-xl flex flex-col justify-between">
          <div>
            <h2 class={headCls}>Pakiet 12 treningów</h2>
            <p class={priceCls}>1 700 zł</p>
            <p class="text-xl font-semibold text-green-400">
              (70,80 zł/os./trening — oszczędzasz 700 zł)
            </p>
          </div>
        </div>

        <div class="bg-gray-800 p-8 rounded-3xl shadow-xl flex flex-col justify-between">
          <div>
            <h2 class={headCls}>Pakiet 16 treningów</h2>
            <p class={priceCls}>2 000 zł</p>
            <p class="text-xl font-semibold text-green-400">
              (62,50 zł/os./trening — oszczędzasz aż 1 200 zł!)
            </p>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Duo;
